import { render, staticRenderFns } from "./_add_items.vue?vue&type=template&id=00fb9b56&scoped=true&"
import script from "./_add_items.vue?vue&type=script&lang=js&"
export * from "./_add_items.vue?vue&type=script&lang=js&"
import style0 from "./_add_items.vue?vue&type=style&index=0&id=00fb9b56&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fb9b56",
  null
  
)

export default component.exports